module.exports = __webpack_public_path__ + "img/seed-60.39fd5240.jpg";